// extracted by mini-css-extract-plugin
export default {"choice-section-container":"gZGTb_","is-disabled":"AqGaGN","read-only":"dz4SmL","choice-section-title":"pb9c24","choice-card-container":"BCM2aE","choice-card":"mY6fdV"};